<script setup lang="ts">
  import { computed } from 'vue';

  /**
   * The store's initials where a logo would go (plan §11.2, D27): white
   * semibold letters on neutral-900 with the storefront logo's rounding, so
   * what the owner sees here is what diners see. Decorative: the surrounding
   * copy names the initials.
   */
  /** Share of the tile the letters take (the storefront's `StoreLogo` ratio). */
  const FONT_RATIO = 0.38;

  const props = withDefaults(
    defineProps<{
      initials: string;
      /** Side of the square, in px. */
      size: number;
      /** `dark`: the storefront's neutral-900 tile; `brand`: orange (the shell's store pill). */
      tone?: 'dark' | 'brand';
    }>(),
    { tone: 'dark' }
  );

  const style = computed(() => ({
    width: `${props.size}px`,
    height: `${props.size}px`,
    fontSize: `${Math.round(props.size * FONT_RATIO)}px`,
  }));
</script>

<template>
  <span
    class="v2-store-monogram"
    :class="`tone-${tone}`"
    :style="style"
    aria-hidden="true"
    >{{ initials }}</span
  >
</template>

<style scoped lang="scss">
  .v2-store-monogram {
    @apply tw-inline-flex tw-shrink-0 tw-select-none tw-items-center tw-justify-center tw-rounded-md tw-font-semibold tw-leading-none;

    &.tone-dark {
      @apply tw-bg-neutral-900 tw-text-on-inverse;
    }

    &.tone-brand {
      @apply tw-bg-orange-600 tw-text-on-color;
    }
  }
</style>
